import { masterV2Api } from "@/apis/interceptor"
import { IEquipmentResponse, IPaginationParamV2, IResponse } from "@/types"

export const equipmentsService = {
  getEquipments: async (params: IPaginationParamV2): Promise<IResponse<IEquipmentResponse>> => {
    const response = await masterV2Api.get<IResponse<IEquipmentResponse>>("/v1/equipments", { params })
    return response.data
  },
}
